import * as deleteServiceActions from '../../redux/actions/deleteServicePopIn.actions';
import { ServiceDTO, ServiceQuery, serviceService } from '../dataProviders';

import { useAppDispatch } from './useTypedSelector';

async function getServicesByQuery(
	query: ServiceQuery
): Promise<ServiceDTO[] | undefined> {
	const resPromise = serviceService.getServicesByQuery(query);
	const res = await resPromise;
	if (res.ok && res.services) {
		return res.services;
	} else {
		return undefined;
	}
}

export const useDeleteServicePopIn = () => {
	const dispatch = useAppDispatch();

	function closeDeleteServicePopIn() {
		dispatch(deleteServiceActions.closeDeleteServicePopIn());
	}

	function openDeleteServicePopIn() {
		dispatch(deleteServiceActions.openDeleteServicePopIn());
	}

	return {
		closeDeleteServicePopIn,
		getServicesByQuery,
		openDeleteServicePopIn,
	};
};
